import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isLoggedIn()) {
      let profile = this.authService.getClaims();
      if (!profile || !profile.roles || profile.roles.length <= 0) {
        this.router.navigate(['accessdenied']);
      }
      return true;
    } 
    // store the URL we need to go after auth in local storage.
    // the auth callback component will redirect to this url after successful auth
    localStorage.setItem('redirectUrl', state.url); // this.authService.redirectPath = state.url;
    this.authService.startAuthentication();
    return false;
  }
}
